<template>
  <div class="container-fluid px-4 view-container">
    <hr />
    <div class="row">
      <div class="col-sm-12 col-md-3">
        <h3>Nowe zlecenie:</h3>
        <hr />

        <div class="form-group" @submit.prevent>
          <input class="form-control my-1" v-model="task.title" placeholder="Klient" />
          <input class="form-control my-1" v-model="task.bike" placeholder="Rower" />
          <!-- <input class="form-control my-1" v-model="task.frame" placeholder="Numer ramy" /> -->
          <input class="form-control my-1" v-model="task.phone" placeholder="Numer telefonu" />
          <input class="form-control my-1" v-model="task.address" placeholder="Adres" />
          <textarea class="form-control my-1" v-model="task.content" placeholder="Opis usterki"></textarea>
          <label class="btn btn-primary" style="width:100%" for="customInputFile">
            <svg
              width="1.5em"
              height="1.5em"
              viewBox="0 0 16 16"
              class="bi bi-camera"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M15 12V6a1 1 0 0 0-1-1h-1.172a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 9.173 3H6.828a1 1 0 0 0-.707.293l-.828.828A3 3 0 0 1 3.172 5H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"
              />
              <path
                fill-rule="evenodd"
                d="M8 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
              />
              <path d="M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
            </svg>
          </label>

          <input
            id="customInputFile"
            class="custom-file-input"
            type="file"
            accept="image/jpeg"
            @change="uploadImage"
          />

          <div class="row pl-3 pr-3 justify-content-end">
            <button
              style="width:100%;"
              :disabled="disabled==1"
              class="btn btn-success"
              @click="addTask"
            >
              <svg
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                class="bi bi-plus-circle"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"
                />
                <path
                  fill-rule="evenodd"
                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
              </svg>
            </button>
            <div v-if="showSuccess" class="alert alert-success" role="alert">Zdjęcie zostało dodane.</div>
            <img
              v-if="task.imageUrl != ''"
              :src="task.imageUrl"
              style="width:100%; max-height:100px;"
            />
          </div>
        </div>

        <h3>Wyszukaj zlecenie</h3>
        <hr />
        <input
          v-model="search"
          class="form-control mr-sm-2"
          type="search"
          placeholder="Wyszukaj zlecenie"
          aria-label="Search"
        />
        <hr />
      </div>

      <div class="col-12 col-md-9">
        <div class="row" v-if="tasks.length">
          <div
            class="card mt-1 ml-3 mr-0"
            style="width:90%;"
            v-for="task in filteredTasks"
            :key="task.id"
          >
            <div class="card-body">
              <div class="row">
                <div v-if="task.imageUrl" class="col-6">
                  <img
                    class="rounded mr-1"
                    style="height:120px; width:120px;"
                    v-bind:src="task.imageUrl"
                    alt
                  />
                </div>
                <div v-else class="col-6">
                    <svg width="130px" height="130px" viewBox="-5 -5 25 25" class="bi bi-camera" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M15 12V6a1 1 0 0 0-1-1h-1.172a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 9.173 3H6.828a1 1 0 0 0-.707.293l-.828.828A3 3 0 0 1 3.172 5H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
  <path fill-rule="evenodd" d="M8 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
  <path d="M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
</svg>
                </div>
                <div class="col-6 text-right">
                  
                    <span class="badge badge-warning ">{{ task.title }}</span>
                  
                  <br>
                  <span
                    class="time-format"
                    v-if="timeFormat"
                    @click="timeFormat= !timeFormat"
                  >{{task.createdOn | formatDate}}</span>
                  

                  <span
                    class="time-format"
                    v-else
                    @click="timeFormat = !timeFormat"
                  >{{task.createdOn | formatDate2}}</span>
                  <br />
                  <span
                    v-if="task.status=='dodany'"
                    class="text-right badge badge-info"
                  >{{task.status}}</span>
                  <span v-else class="text-right badge badge-success">{{task.status}}</span>
                  <br>
                  <span style="font-size:12px;">{{task.taskId}}/{{task.createdOn | formatDate3}}</span>
                  <hr>
                  <span class="float-left text-left ml-1 mt-1" style="font-size:12px;" >{{task.bike}}</span>
                </div> 
              </div>

              <hr />
              
              
              <div class="row justify-content-center mt-0">
                <div class="col-6 text-center">
                  <button class="btn btn-light" style="width:100%;">
                    <a :href="`tel:${task.phone}`" style="text-decoration:none;">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        class="bi bi-telephone"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3.925 1.745a.636.636 0 0 0-.951-.059l-.97.97c-.453.453-.62 1.095-.421 1.658A16.47 16.47 0 0 0 5.49 10.51a16.471 16.471 0 0 0 6.196 3.907c.563.198 1.205.032 1.658-.421l.97-.97a.636.636 0 0 0-.06-.951l-2.162-1.682a.636.636 0 0 0-.544-.115l-2.052.513a1.636 1.636 0 0 1-1.554-.43L5.64 8.058a1.636 1.636 0 0 1-.43-1.554l.513-2.052a.636.636 0 0 0-.115-.544L3.925 1.745zM2.267.98a1.636 1.636 0 0 1 2.448.153l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.47 17.47 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969z"
                        />
                      </svg>
                    </a>
                  </button>
                </div>
                <div class="col-6 text-center">
                  <button class="btn btn-light" style="width:100%;">
                    <a :href="`sms:${task.phone}&body=Serwis Zico-Bike: `">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        class="bi bi-chat-left-text"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M14 1H2a1 1 0 0 0-1 1v11.586l2-2A2 2 0 0 1 4.414 11H14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                        />
                      </svg>
                    </a>
                  </button>
                </div>
              </div>

              <hr />
              <div class="row d-flex justify-content-center">
                <div class="col-6">
                  <button class="btn btn-secondary" style="width:100%;" @click="addComment(task)">
                    <svg
                      width="1.5em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-stickies"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M0 1.5A1.5 1.5 0 0 1 1.5 0H13a1 1 0 0 1 1 1H1.5a.5.5 0 0 0-.5.5V14a1 1 0 0 1-1-1V1.5z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M2 3.5A1.5 1.5 0 0 1 3.5 2h11A1.5 1.5 0 0 1 16 3.5v6.086a1.5 1.5 0 0 1-.44 1.06l-4.914 4.915a1.5 1.5 0 0 1-1.06.439H3.5A1.5 1.5 0 0 1 2 14.5v-11zM3.5 3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6.086a.5.5 0 0 0 .353-.146l4.915-4.915A.5.5 0 0 0 15 9.586V3.5a.5.5 0 0 0-.5-.5h-11z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10.5 10a.5.5 0 0 0-.5.5v5H9v-5A1.5 1.5 0 0 1 10.5 9h5v1h-5z"
                      />
                    </svg>
                    {{ task.comments }}
                  </button>
                </div>
                <div class="col-6">
                  <button class="btn btn-primary" style="width:100%;" @click="openTask(task)">
                    <svg
                      width="1.5em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-arrows-fullscreen"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.464 10.536a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.5-.5v-3.5a.5.5 0 0 1 .5-.5z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M5.964 10a.5.5 0 0 1 0 .707l-4.146 4.147a.5.5 0 0 1-.707-.708L5.257 10a.5.5 0 0 1 .707 0zm8.854-8.854a.5.5 0 0 1 0 .708L10.672 6a.5.5 0 0 1-.708-.707l4.147-4.147a.5.5 0 0 1 .707 0z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10.5 1.5A.5.5 0 0 1 11 1h3.5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-1 0V2h-3a.5.5 0 0 1-.5-.5zm4 9a.5.5 0 0 0-.5.5v3h-3a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10 9.964a.5.5 0 0 0 0 .708l4.146 4.146a.5.5 0 0 0 .708-.707l-4.147-4.147a.5.5 0 0 0-.707 0zM1.182 1.146a.5.5 0 0 0 0 .708L5.328 6a.5.5 0 0 0 .708-.707L1.889 1.146a.5.5 0 0 0-.707 0z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M5.5 1.5A.5.5 0 0 0 5 1H1.5a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0V2h3a.5.5 0 0 0 .5-.5z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>

    <task-modal :oneTask="oneTask" :key="taskKey" @clear-comments="taskReload()"></task-modal>
    <comment-modal :oneTask="oneTask" :key="commentKey" @clear-comment="commentReload()"></comment-modal>
    <!-- <print-modal :oneTask="oneTask" :key="printKey"> </print-modal> -->
  </div>
</template>
<script>
// import { commentsCollection } from '@/firebase'

import { mapState } from "vuex";
import { fb, db } from "../firebase";
import moment from "moment";
import CommentModal from "@/components/CommentModal";
import { commentsCollection } from "@/firebase";
import TaskModal from "@/components/TaskModal";
// import PrintModal from "@/components/PrintModal"
// import CommentModal from '@/components/CommentModal'

export default {
  data() {
    return {
      task: {
        title: "",
        bike: "",
        frame: "",
        phone: "",
        address: "",
        content: "",
        imageUrl: "",
      },
      search: "",
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      taskComments: [],
      oneTask: "",
      timeFormat: false,
      taskKey: 0,
      commentKey: 100,
      printKey: 1000,
      disabled: 0,
      showSuccess: false,

      // userProfile: {}
    };
  },

  components: {
    "task-modal": TaskModal,
    "comment-modal": CommentModal,
    // "print-modal": PrintModal
  },

  computed: {
    ...mapState(["userProfile", "tasks"]),
    filteredTasks() {
      return this.tasks.filter((item) => {
        if (item.status != "zrealizowany") {
          return item.title.toUpperCase().includes(this.search.toUpperCase());
        }
      });
    },
  },
  methods: {
    taskReload() {
      this.taskKey += 1;
    },
    commentReload() {
      this.commentKey += 1;
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    uploadImage(e) {
      let file = e.target.files[0];
      Object.defineProperty(file, "name", {
        writable: true,
        value: this.uuidv4(),
      });
      //   file.name = this.uuidv4()

      var storageRef = fb.storage().ref("tasks/" + file.name);
      storageRef.put(file);

      let uploadTask = storageRef.put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          this.disabled = 1;
        },
        (error) => {},
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.task.imageUrl = downloadURL;
            this.disabled = 0;
            this.showSuccess = true;

            setTimeout(() => {
              this.showSuccess = false;
            }, 2000);
          });
        }
      );
    },
    addTask() {
      this.$store.dispatch("createTask", {
        content: this.task.content,
        title: this.task.title,
        bike: this.task.bike,
        frame: this.task.frame,
        phone: this.task.phone,
        address: this.task.address,
        imageUrl: this.task.imageUrl,
      });
      (this.task.content = ""),
        (this.task.title = ""),
        (this.task.bike = ""),
        (this.task.frame = ""),
        (this.task.phone = ""),
        (this.task.address = "");
      this.task.imageUrl = "";
    },
    openTask(oneTaskId) {
      this.$modal.show("task-modal");
      this.oneTask = oneTaskId;
    },
    addComment(task) {
      this.$modal.show("comment-modal");
      this.oneTask = task;
    },
    clearComments() {
      this.taskComments = [];
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      moment.locale("pl");
      return moment(date).fromNow();
    },
    formatDate2(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      moment.locale("pl");
      return moment(date).format('LL');
    },
    formatDate3(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      moment.locale("en");
      return moment(date).format('L');
    },
  },
};
</script>
<style scoped>
.view-container {
  background-color: #f5f7f9;
}
.card {
  margin: 8px;
  max-width: 320px;
}

.time-format {
  color: gray;
  font-size: 12px;
  cursor: pointer;
}
.badge-warning {
  font-weight: 500;
}
.custom-file-input {
  display: none;
}
a {
  color: #000;
}
</style>